/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

export const NOTES_FETCH_REQUEST = 'NOTES_FETCH_REQUEST';
export const NOTES_FETCH_REQUEST_SUCCESS = 'NOTES_FETCH_REQUEST_SUCCESS';
export const NOTES_FETCH_REQUEST_FAILURE = 'NOTES_FETCH_REQUEST_FAILURE';

export const NOTES_CLEAN_REQUEST = 'NOTES_CLEAN_REQUEST';
